var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5508 5.10938C14.5508 5.0625 14.5586 5.01563 14.5586 4.96875C14.5586 2.42969 12.5352 0.375 10.0391 0.375C8.23828 0.375 6.69141 1.44531 5.96484 2.99219C5.64844 2.83203 5.29297 2.73828 4.91797 2.73828C3.76562 2.73828 2.80469 3.59375 2.62109 4.71094C1.23828 5.1875 0.25 6.51172 0.25 8.07031C0.25 10.0312 1.81641 11.625 3.74609 11.625H7.75V8.5H5.86719L9 5.23047L12.1328 8.49609H10.25V11.6211H14.5586C16.3242 11.6211 17.75 10.1562 17.75 8.36328C17.75 6.57031 16.3164 5.11328 14.5508 5.10938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.3b1dce94e0e6218b9642181930826ac0.svg";
export { ForwardRef as ReactComponent };